import type { AppModule } from '@teamango/core';

import * as routes from './routes.js';

export const LabelsModule: AppModule = {
  routes,
};
